import "bootstrap";
import * as $ from "jquery";
import * as Popper from "popper.js";
import "slick-carousel";

window.$ = $;
window.jQuery = $;
window.Popper = Popper;

$(function() {
  // Init bootstrap tooltips
  $('[data-toggle="tooltip"]').tooltip();
});

// Navbar
const $body = $("body");
const $dropdown = $(".navbar-nav .dropdown");
const $dropdownToggle = $(".dropdown-toggle");
const $dropdownMenu = $(".dropdown-menu");
const showClass = "show";

const addFocusToDropdown = function(item) {
  item.addClass(showClass);
  item.find($dropdownToggle).attr("aria-expanded", "true");
  item.find($dropdownMenu).addClass(showClass);
};

const removeFocusFromDropdown = function(items) {
  items.removeClass(showClass);
  items.find($dropdownToggle).attr("aria-expanded", "false");
  items.find($dropdownMenu).removeClass(showClass);
};

$(window).on("load resize", function() {
  if (this.matchMedia("(min-width: 992px)").matches) {
    const handleFocus = function() {
      const $this = $(this);
      removeFocusFromDropdown($dropdown);
      addFocusToDropdown($this);
    };

    const handleBlur = function() {
      removeFocusFromDropdown($dropdown);
    };

    $dropdown
      .on("mouseenter focusin", handleFocus)
      .on("mouseleave", handleBlur);

    $body.on("focusin", function() {
      const $primaryNav = $(".navbar-nav.navbar-primary");
      const $activeElement = $(document.activeElement);

      if ($primaryNav.find($activeElement).length <= 0) {
        handleBlur();
      }
    });
  } else {
    const $navbarToggler = $(".navbar-toggler");
    const $lastNavItem = $(".nav-item").last();

    // The blur event on the last menu item should close the menu.
    $lastNavItem.on("focusout", function(e) {
      $navbarToggler.trigger("click");
    });

    $dropdown.off("mouseenter mouseleave focusin");
    $body.on("focusin");
  }
});

// Recipe cook mode (keep screen awake)
window.addEventListener("DOMContentLoaded", () => {
  const wakeLockToggle = document.getElementById("wakeLock");
  if (wakeLockToggle) {
    if ("wakeLock" in navigator) {
      let wakeLock = null;
      const wakeLockEnable = async () => {
        try {
          wakeLock = await navigator.wakeLock.request("screen");
        } catch (err) {
          console.error(`${err.name}, ${err.message}`);
        }
      };
      wakeLockToggle.addEventListener("click", () => {
        if (wakeLockToggle.checked) {
          wakeLockEnable();
        } else {
          wakeLock.release().then(() => {
            wakeLock = null;
          });
        }
      });
      // lock is automatically released when document becomes inactive (e.g., tab change, window minimized, etc.)
      // so we need to acquire lock again when the tab becomes visible
      document.addEventListener("visibilitychange", async () => {
        if (wakeLock !== null && document.visibilityState === "visible") {
          wakeLock = await navigator.wakeLock.request("screen");
        }
      });
    } else {
      // hide the switch if unsupported
      wakeLockToggle.parentElement.hidden = true;
    }
  }
});
